import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-password-validators',
  templateUrl: './password-validators.component.html',
  styleUrl: './password-validators.component.scss'
})
export class PasswordValidatorsComponent {
  @Input() value = '';
}
